export default function FramerKhair(){
    return(
        window.location.assign('https://bikhairapp.framer.website/')
    )
}